import VehicleWidget from "./VehicleWidget";
export default function InPhotosWrapper({ service, refetch }: any) {
  if (service?.inphotos === undefined) {
    return <></>;
  }

  const side1 = service?.inphotos[0];
  const side2 = service?.inphotos[1];
  const side3 = service?.inphotos[2];
  const side4 = service?.inphotos[3];
  const side5 = service?.inphotos[4];

  return (
    <div className="book" id="invoice-doc">
      <div className="page">
        <div className="subpage2">
          <div className="p-1">
            <div
              className="flex justify-center items-center"
              style={{ fontSize: 16 }}
            >
              INTERIOR PHOTOS
            </div>
            <div className="flex mb-4">
              <div className="w-1/2 flex justify-center h-auto mx-4">
                <VehicleWidget
                  item={side1}
                  service={service}
                  refetch={refetch}
                />
              </div>
              <div className="w-1/2 flex justify-center h-auto mx-4">
                <VehicleWidget
                  item={side2}
                  service={service}
                  refetch={refetch}
                />
              </div>
            </div>
            <div className="flex mb-4">
              <div className="w-1/2 flex justify-center h-auto mx-4">
                <VehicleWidget
                  item={side3}
                  service={service}
                  refetch={refetch}
                />
              </div>
              <div className="w-1/2 flex justify-center h-auto mx-4">
                <VehicleWidget
                  item={side4}
                  service={service}
                  refetch={refetch}
                />
              </div>
            </div>
            <div className="flex justify-center">
              <div className="w-1/2 flex justify-center h-auto mx-4">
                <VehicleWidget
                  item={side5}
                  service={service}
                  refetch={refetch}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
